import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../structure/row';
import { Cell, LEFT } from '../structure/cell';
import { show } from '../../../actions/free_mobile_fitting_light_box_actions';
import getTranslatedText from '../../../helper/get_translated_text';

export function FreeFitting({ fittingPromotion: { promotionName } }) {
  return (
    <Row className="products-price">
      <Cell side={LEFT} colSpan={2}>
        <div className="sale-price">
          {promotionName === 'free_fitting' && (
            <span className="sale-price__tag sale-price__tag--free-fitting">
              {getTranslatedText('pdp-free-fitting-badge')}
            </span>
          )}
          {promotionName === 'free_mobile_fitting' && (
            <span onClick={show} className="sale-price__tag sale-price__tag--free-mobile-fitting cursor-pointer">
              {getTranslatedText('pdp-free-mobile-fitting-badge')}
            </span>
          )}
        </div>
      </Cell>
    </Row>
  );
}

FreeFitting.propTypes = {
  fittingPromotion: PropTypes.object.isRequired,
};
